<template>
  <div class="cart-upload-arc">
    <div
      class="cart-upload-arc-cap"
      :class="{ 'slide-in': slideIn }"
      :style="{ color: globe.mainTextColor }"
      @click.stop
    >
      <span v-if="uploading" class="label">
        bestanden<br />uploaden… {{ uploadProgress }}%
      </span>
      <span
        v-else-if="pendingFilesCount > 0"
        class="label"
        :class="{ pointer: !inProductOrder }"
        @click="goToProductOrder"
      >
        {{ pendingFilesCount }}
        {{ pendingFilesCount === 1 ? 'bestand' : 'bestanden' }}<br />zonder
        product
      </span>
      <span v-else class="label">bestanden<br />uploaden</span>

      <order-file-uploader
        @files-added="uploading = true"
        @file-progress="onFileProgress"
        @upload-done="onUploadDone"
        @file-removed="onUploadDone"
      >
        <uploader-btn
          class="plus"
          aria-label="Bestanden uploaden"
          :style="{
            backgroundColor: globe.buttonBackgroundColor,
            color: globe.buttonIconColor
          }"
        ></uploader-btn>
      </order-file-uploader>
    </div>
  </div>
</template>

<script>
import { mapStores } from 'pinia'
import { useFileListStore } from '@/stores/FileList.store'
import InteractionMixin from '@/mixins/InteractionMixin'
import OrderFileUploader from '@/components/ui/file-upload/OrderFileUploader.vue'

// De boog schuift alleen omhoog bij het laden van het thema, niet bij elke
// latere remount (bv. terugkomen uit de checkout)
let hasSlidIn = false

export default {
  components: { OrderFileUploader },
  mixins: [InteractionMixin],
  data() {
    return {
      uploading: false,
      uploadProgress: 0,
      slideIn: !hasSlidIn
    }
  },
  created() {
    hasSlidIn = true
  },
  methods: {
    onFileProgress(value) {
      // OrderFileUploader geeft bij 100% soms een ongeldige waarde door
      if (!isNaN(value)) {
        this.uploadProgress = value
      }
    },
    onUploadDone() {
      this.uploading = false
      this.uploadProgress = 0
    },
    goToProductOrder() {
      if (this.inProductOrder) {
        return
      }

      const productOrder = this.rootStore.interactions.find(
        (ia) => ia.destination === 'productOrder'
      )

      if (productOrder) {
        this.startInteraction(productOrder)
      } else {
        this.$router.push({ name: 'productOrder' })
      }
    }
  },
  computed: {
    ...mapStores(useFileListStore),
    globe() {
      return this.rootStore.globe
    },
    inProductOrder() {
      // Op de productOrder-pagina heeft navigeren geen zin: je bent er al
      return this.$route.name === 'productOrder'
    },
    pendingFiles() {
      // Bestanden die zijn geupload om een product bij te kiezen, maar nog niet
      // in de winkelwagen zitten. Bestanden die als bijlage of adreslijst bij een
      // product horen tellen niet mee.
      return this.fileListStore.fileList.filter(
        (file) =>
          !file.inCart &&
          file.uploadFileType !== 'ADDRESS_LIST' &&
          file.uploadFileType !== 'ATTACHMENT_FILE'
      )
    },
    pendingFilesCount() {
      return this.pendingFiles.length
    }
  }
}
</script>

<style lang="scss" scoped>
// Clipt de boog op de vorm van de globe
.cart-upload-arc {
  position: absolute;
  inset: 0;
  border-radius: 50%;
  overflow: hidden;
  pointer-events: none;
}

// Grijze boog onderin de globe: een even grote cirkel, naar beneden geschoven
.cart-upload-arc-cap {
  position: absolute;
  top: 65%;
  left: 0;
  width: 100%;
  height: 100%;
  // Inhoud bovenin de boog; de rest valt buiten de globe
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
  border: none;
  border-radius: 50%;
  padding: 13px 0 0;
  //  background-color: #fbfbfb;
  //  box-shadow: 0 -11px 15px -11px #00000040;
  box-shadow: 0 -11px 16px -14px rgba(0, 0, 0, 0.2);
  font-family: inherit;
  font-size: 11px;
  font-weight: 500;
  line-height: 15px;
  text-align: center;
  cursor: default;
  pointer-events: auto;

  &.slide-in {
    animation: arc-slide-in 0.4s ease-out 0.2s both;
  }
}

// Vanuit onder de rand van de globe omhoog schuiven
@keyframes arc-slide-in {
  from {
    transform: translateY(40%);
  }
  to {
    transform: translateY(0);
  }
}

@media (prefers-reduced-motion: reduce) {
  .cart-upload-arc-cap.slide-in {
    animation: none;
  }
}

.label {
  display: block;
  padding-bottom: 2px;

  &.pointer {
    cursor: pointer;
  }
}

.plus {
  position: relative;
  display: block;
  width: 24px;
  height: 24px;
  margin: 6px auto 0;
  padding: 0;
  border: none;
  border-radius: 50%;
  cursor: pointer;
  transition: box-shadow 0.2s;

  &:hover {
    box-shadow: var(--default-shadow);
  }

  // De pseudo-elementen vormen het plus-teken
  &::before,
  &::after {
    content: '';
    position: absolute;
    top: 50%;
    left: 50%;
    background-color: currentColor;
    transform: translate(-50%, -50%);
  }

  &::before {
    width: 10px;
    height: 2px;
  }

  &::after {
    width: 2px;
    height: 10px;
  }
}
</style>
